module.exports = __webpack_public_path__ + "img/48.ef8df758.jpg";